module.exports = __webpack_public_path__ + "static/media/world-sm.d2f37a4d.jpg";